<template lang='pug'>
li.articleCard-item(@click="goTo")
  //- top section of articleCard
  .articleCard-top
    .articleCard-image
      .articleCard-imageBackground(v-if="info.thumbnailUrl" :style="'background-image: url(' + info.thumbnailUrl + ');'")
      .articleCard-imageBackground(v-else-if="info.category && info.category.thumbnailUrl" :style="'background-image: url(' + info.category.thumbnailUrl + ');'")
      .articleCard-imageBackground(v-else-if="info.type=='verifiedGov'" :style="defaultPublicImage")
      .articleCard-imageBackground(v-else :style="defaultImage")
    .articleCard-tag(v-if="info.type=='verifiedPartner'" :class="getTagClass(info.tag.id, 'articleCard-tag')") {{ info.tag[$store.state.lang] }}
    .articleCard-tag(v-else :class="getTagClass(5, 'articleCard-tag')") {{ "澄清" }}

  //- bottom section of articleCard
  .articleCard-middle
    v-clamp.articleCard-text.heading-cardTitle(autoresize :max-lines="2") {{ info.content }}
    .articleCard-info
      .articleNoThumbnail-time
        .color--greyBlue90 {{ time }}
      .articleNoThumbnail-report(v-if="info.type=='verifiedPartner'")
        i.icon-report2.articleNoThumbnail-icon
        .color--greyBlue90 {{ getNumberString(info.reporterCount) }}
      .articleNoThumbnail-follow(v-if="info.type=='verifiedPartner'")
        i.articleNoThumbnail-icon.icon-follow
        .color--greyBlue90 {{ getNumberString(info.followerCount) }}
  .articleCard-bottom(v-if="info.type=='verifiedPartner'")
    .articleCard-dot(:class="getTagClass(info.tag.id, 'articleCard-dot')" v-if="info.tag.id !== 1")
    .articleCard-info2(v-if="info.comments.length !== 0")
      span.articleCard-info-partner {{ info.comments[0].partner.name}}
      span(v-if="info.comments.length > 1") ...
        span {{ "(" + info.comments.length + ")" }}
  .articleCard-bottom(v-else)
    .articleCard-info2
      span.articleCard-info-partner {{ info.govOption.name }}
</template>
<script>
import { getTime, getTagClass, getNumberString } from '@/plugins/tool.js'
import VClamp from 'vue-clamp'
export default {
  components: {
    VClamp
  },
  props: {
    info: Object
  },
  data() {
    return {
      getNumberString: getNumberString
    }
  },
  computed: {
    time() {
      return getTime(this.info.updatedAt)
    },
    defaultImage() {
      return "background-image: url('" + process.env.VUE_APP_CDN_URL + "/category/fig-default-2.png');";
    },
    defaultPublicImage() {
      return "background-image: url('" + process.env.VUE_APP_CDN_URL + "/category/fig-public-affairs.png');";
    }
  },
  methods: {
    goTo() {
      if (this.info.type == "verifiedPartner") {
        this.$router.push({
          "path": "/news",
          "query": {
            "categoryId": this.info.category.id,
            "articleId": this.info.id
          }
        })
      }
      else {
        window.location.href = this.info.url
      }
    },
    getTagClass(tagId, className) {
      return getTagClass(tagId, className)
    }
  }
}
</script>
<style scoped src='./verified_article.vue.css'></style>
